import {
  Avatar,
  createPersonAvatarProps,
  Icons,
  Typography,
  View,
  YStack,
} from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';

const ITEM_SIZE = 80;
const RING_WIDTH = 2;

interface BottomNavProfileItemProps {
  active: boolean;
  label: string;
  name: string | null;
  onPress: () => void;
  uuid: string | null;
}

export const BottomNavProfileItem: React.FC<BottomNavProfileItemProps> = ({
  active,
  label,
  name,
  onPress,
  uuid,
}) => {
  const theme = useTheme();

  return (
    <YStack
      accessibilityRole="button"
      accessibilityState={{ selected: active }}
      alignItems="center"
      gap="$4"
      justifyContent="center"
      minWidth={0}
      onPress={onPress}
      paddingVertical="$8"
      width={ITEM_SIZE}
    >
      <View
        borderColor={active ? theme.sk.color.text.primary : 'transparent'}
        borderRadius={theme.sk.radii.radiusRound}
        borderWidth={RING_WIDTH}
        margin={RING_WIDTH}
      >
        {name && uuid ? (
          <Avatar {...createPersonAvatarProps(name, uuid)} size="$xs" />
        ) : (
          <Icons.CircleDashed
            color={theme.sk.color.icon.secondary}
            size="$24"
          />
        )}
      </View>
      <Typography
        bold={active}
        color={active ? '$textPrimary' : '$textSecondary'}
        numberOfLines={1}
        size="$2xs"
        textAlign="center"
        variant="caption"
        width="100%"
      >
        {label}
      </Typography>
    </YStack>
  );
};
